import { render, staticRenderFns } from "./CameraMenu.vue?vue&type=template&id=82f95bc8&scoped=true"
import script from "./CameraMenu.vue?vue&type=script&lang=js"
export * from "./CameraMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f95bc8",
  null
  
)

export default component.exports